export default "__VITE_ASSET__DZ3YvMM1__"